import createAbsoluteMonthlyRecurrence from './createAbsoluteMonthlyRecurrence';
import createAbsoluteYearlyRecurrence from './createAbsoluteYearlyRecurrence';
import createDailyRecurrence from './createDailyRecurrence';
import createWeeklyRecurrenceFromDate from './createWeeklyRecurrenceFromDate';
import getRecurrenceDefaultEnd from './getRecurrenceDefaultEnd';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { RecurrenceConstants } from './RecurrenceTypes';
import * as trace from 'owa-trace';
import type { DisplayDate } from 'owa-datetime';

export default function createRecurrence(
    recurrenceType: string,
    startDate: DisplayDate,
    interval: number = 1
): RecurrenceType {
    let type = recurrenceType;
    if (type == RecurrenceConstants.Custom) {
        /**
         * On Click of custom or weekly in recurrence menu
         * creates a weekly recurrence
         */
        type = RecurrenceConstants.Weekly;
    }

    const endDate = getRecurrenceDefaultEnd(type, startDate);

    switch (type) {
        case RecurrenceConstants.None:
            return null;
        case RecurrenceConstants.Daily:
            return createDailyRecurrence(startDate, interval, endDate);
        case RecurrenceConstants.Weekly:
            return createWeeklyRecurrenceFromDate(startDate, interval, endDate);
        case RecurrenceConstants.Monthly:
            return createAbsoluteMonthlyRecurrence(startDate, interval, endDate);
        case RecurrenceConstants.Yearly:
            return createAbsoluteYearlyRecurrence(startDate, endDate);
        default:
            trace.errorThatWillCauseAlert('unknown recurrence type: ' + recurrenceType);
            return null;
    }
}
